import { useDispatch } from 'react-redux';
import { authActions } from 'reduxStore/auth/slice';
import { Button, Flex } from 'zui/Antd';

// Ways out of a failed boot, under the loader's message: reload the app, or sign out and start over.
const BootErrorActions = () => {
	const dispatch = useDispatch();
	return (
		<Flex gap={10} style={{ marginTop: 18 }}>
			<Button onClick={() => window.location.reload()}>Reload</Button>
			<Button
				type='text'
				style={{ color: 'rgba(255,255,255,0.75)' }}
				onClick={() => dispatch(authActions.logout())}
			>
				Sign out
			</Button>
		</Flex>
	);
};

export default BootErrorActions;
